import { render, staticRenderFns } from "./AbTeamPer.vue?vue&type=template&id=6ccf5ab4&scoped=true"
import script from "./AbTeamPer.vue?vue&type=script&lang=js"
export * from "./AbTeamPer.vue?vue&type=script&lang=js"
import style0 from "./AbTeamPer.vue?vue&type=style&index=0&id=6ccf5ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf5ab4",
  null
  
)

export default component.exports